export default {"src":"/_next/static/media/crafts.6a22ceb2.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};